import React, { Component } from 'react';
import NoData from './NoData';
import InputItem from './InputItem';
import Loading from './loading';

class CardItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listId: '',
      show: false,
      isCreate: false,
      activate: false,
      showInput: true
    };
  }

  componentDidMount() {
    if (this.props.items.datos.length == 0) {
      this.setState({ isCreate: false });
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.isCancel != prevProps.isCancel) {
      this.setState({ isCreate: false });
    }
  }

  scrollToBottom() {
    const scrollHeight = this.el.scrollHeight;
    const height = this.el.clientHeight;
    const maxScrollTop = scrollHeight - height;
    this.el.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
  }

  //show input on escape
  hanhleShowInput = () => {
    this.setState({ showInput: false });
  };
  handleClick = e => {
    e.stopPropagation();
    if (this.props.listId) {
      this.setState({ isCreate: true, showInput: true });

      this.props.showIcon(e);
      this.props.handleDisableListHover();
    } else {
      this.setState({ isCreate: false /*addItemError: true*/ });
      this.props.handleShowTooltip(true);
    }
    let itemInput = document.getElementById('fname-item');
    if (itemInput) {
      itemInput.focus();
    }
  };

  handleActivate = e => {
    if (this.props.items.datos.length > 0) {
      this.setState({ activate: true });
    }
  };

  render() {
    let {
      list,
      title,
      create,
      name,
      action,
      legend,
      handleGetListId,
      listId,
      listName,
      handleItemData,
      dataItem,
      handleShowModal,
      handleShowModalEdit,
      handleCancel,
      handleSaveItem,
      language,
      items,
      showIcon,
      itemIcon,
      showEdit,
      showDelete,
      handleSaveChanges,
      handleCancelChanges,
      handleShowTooltip,
      addItemError,
      showCancelOnTyping
    } = this.props;

    list = list ? list : [];
    dataItem = dataItem ? dataItem : [];
    listId = listId ? listId : [];

    return (
      <div className="card-container bd-bottom">
        <div className="header-one">
          <div className="item-right gray-item">
            <h5>
              {title}
              <span className="_item-title"> {` ${listName ? listName : ''}`}</span>
            </h5>
          </div>
          <div className="right-item">
            <div>
              <div className="tooltip-wraper card-item-wraper">
                <span
                  className={`fa-stack fa-1x orange-plus ${
                    items.datos.length > 0 ? 'list-icon-create add-item-button' : 'add-item-button'
                  }`}
                  onClick={listId ? this.handleClick : null}
                >
                  <i className="fas fa-circle fa-stack-1x " />
                  <i className="fas fa-plus fa-stack-1x fa-inverse" />
                </span>

                <div className="toolti">
                  <span
                    className={`tooltptext tooltptext-item ${
                      addItemError ? 'show-tool-tip' : 'hide-tool-tip'
                    }`}
                  >
                    <i
                      className="fas fa-times-circle item-error"
                      onClick={this.props.handleShowTooltip}
                    />
                    {this.props.language.card.item.tooltip_err_mes}
                  </span>
                </div>
              </div>
              <span className="create-text create-text-item"> {create} </span>
            </div>
          </div>
        </div>
        <div className="header-two">
          <div className="header-two-item-right">
            <h5>{name}</h5>
          </div>
          <div className="header-two-right-item">
            <div>
              <h5>{action}</h5>
            </div>
          </div>
        </div>
        <div
          className={(items.datos.length > 0) | itemIcon ? 'card-content-input' : 'card-content'} // modification has been made here
          ref={el => {
            this.el = el;
          }}
        >
          {(items.datos.length > 0) | itemIcon ? ( // modification as been made here
            <InputItem
              handleItemData={handleItemData}
              handleGetListId={handleGetListId}
              dataItem={dataItem}
              listId={listId}
              listName={listName}
              handleShowModal={handleShowModal}
              handleShowModalEdit={handleShowModalEdit}
              language={language}
              items={items}
              activate={this.state.activate}
              itemIcon={itemIcon}
              hanhleShowInput={this.hanhleShowInput}
              showInput={this.state.showInput}
              handleShowTooltip={handleShowTooltip}
              showCancelOnTyping={showCancelOnTyping}
            />
          ) : (
            <NoData legend={legend} />
          )}
          {items.loading ? <Loading /> : ''}
        </div>
        <div
          className={`${
            dataItem.length !== 0 || showDelete || showEdit ? 'btn-container' : 'btn-hide'
          }`}
        >
          <button className="btn btn-secondary" onClick={handleSaveChanges}>
            {language.card.item.btn_save}
          </button>
        </div>
        {/*listId.length !== 0*/}
        <div className={`${itemIcon || showEdit ? 'btn-containe' : 'btn-hide'}`}>
          <button className="btn btn-cancel" onClick={handleCancelChanges}>
            {language.card.item.btn_cancel}
          </button>
        </div>
      </div>
    );
  }
}

export default CardItem;



// WEBPACK FOOTER //
// ./source/client/components/dynamic_list/CardItem.jsx